import Vue from 'vue';
import Component from 'vue-class-component';
import WelcomePanelComponent from '@/components/welcome-panel/WelcomePanel.component';
import FormsComponent from '@/components/forms/Forms.component';
import MessagesComponent from '@/components/messages/Messages.component';
import { Getter, Mutation } from 'vuex-class';
import { FORM_SUCCESS_DIALOG, SET_FORM_SUCCESS_DIALOG } from '@/types/form.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { SET_IS_RECAPTCHA_V2_USED, USER_DETAILS } from '@/types/authentication.types';
import { UserDetails } from '@/models/UserDetails.model';

@Component({
  components: {
    WelcomePanelComponent,
    FormsComponent,
    MessagesComponent,
  },
})
export default class LobbyComponent extends Vue {
  @Mutation(SET_FORM_SUCCESS_DIALOG, StoreNamespace.FORM) public setFormSuccessDialog;

  @Getter(FORM_SUCCESS_DIALOG, StoreNamespace.FORM) public formSuccessDialog!: boolean;
  @Getter(USER_DETAILS, StoreNamespace.AUTHENTICATION) public userDetails!: UserDetails;

  public closeSuccessDialog() {
    this.setFormSuccessDialog(false);
  }

  public destroyed() {
    this.setFormSuccessDialog(false);
  }

}

